// extracted by mini-css-extract-plugin
module.exports = {"Report":"Report_Report__I7vj9","status":"Report_status__1ePDr","ok":"Report_ok__2LlgA","fail":"Report_fail__1qUnC"};